import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const TICKET_STATUS = `${LOCAL_URL}/ticket/ticketStatus`
export const LIST_TICKETS = `${LOCAL_URL}/ticket/listTicket`
export const CREATE_TICKET = `${LOCAL_URL}/ticket/createTicket`
export const LIST_ASSIGNEES = `${LOCAL_URL}/ticket/listAssignees`
export const CREATE_COMMENT = `${LOCAL_URL}/ticket/createComment`
export const DELETE_COMMENT = `${LOCAL_URL}/ticket/deleteComment`
export const CHANGE_STATUS = `${LOCAL_URL}/ticket/ticketStatusChange`
export const CHANGE_ASSIGNEE = `${LOCAL_URL}/ticket/ticketAssign`
export const LIST_PROPERTY = `${LOCAL_URL}/property/simpleListProperty`
export const UPLOAD_DOC = `${LOCAL_URL}/ticket/update`

const headers = {
  Authorization: API_TOKEN,
}

// function to get ticket status
export async function getTicketStatus() {
  return await axios.get(TICKET_STATUS, {headers})
}

// function to get list of tickets
export async function getTicketList(
  offset: number,
  limit: number,
  assignee_uuid: string[] = [],
  ticket_status_uuid: string[] = [],
  from_date: string = "",
  to_date: string = "",
  search:string = ""
) {
  return await axios.post(LIST_TICKETS, {
    offset,
    limit,
    assignee_uuid,
    ticket_status_uuid,
    from_date,
    to_date,
    search
  })
}

// function to create ticket
export async function createTickets(
  ticket_type_id: number,
  ticket_end_job_type_uuid: string,
  assignee_uuid: string,
  ticket_title: string,
  ticket_description: string,
  ticket_docs: {file: string}[]
) {
  return await axios.post(CREATE_TICKET, {
    ticket_type_id,
    ticket_end_job_type_uuid,
    assignee_uuid,
    ticket_title,
    ticket_description,
    ticket_docs,
  })
}

// function to get assignees
export async function getAssignees(property_uuid: string) {
  return await axios.post(LIST_ASSIGNEES, {property_uuid})
}

// function to create comment
export async function createComment(ticket_comment_text: string, ticket_uuid: string) {
  return await axios.post(CREATE_COMMENT, {ticket_comment_text, ticket_uuid})
}

// function to create comment
export async function deleteComment(ticket_comment_uuid: string) {
  return await axios.post(DELETE_COMMENT, {ticket_comment_uuid})
}

// function to change ticket status
export async function changeStatus(ticket_status_uuid: string, ticket_uuid: string) {
  return await axios.post(CHANGE_STATUS, {ticket_status_uuid, ticket_uuid})
}

// function to change the ticket assignee
export async function changeAssignee(account_uuid: string, ticket_uuid: string) {
  return await axios.post(CHANGE_ASSIGNEE, {account_uuid, ticket_uuid})
}

// function to change the ticket assignee
export async function getListProperty() {
  return await axios.get(LIST_PROPERTY)
}

export async function uploadDocAndPrice(ticket_docs: {file: string}[], price: number, ticket_uuid: string) {
  return await axios.put(UPLOAD_DOC, {ticket_docs, price, ticket_uuid})
}
